import 'bootstrap/dist/css/bootstrap.min.css';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Content from '../components/Content';
import '../components/Jobs/Jobs.css';
import Table from '../components/Podcasts/Table';

import { useSelector } from 'react-redux';
import Skeleton from '../components/ui/Skeleton/Skeleton';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { RootState } from '../redux/store';
import { UserInfoType } from '../types/AppTypes';
import { fetchPodcasts } from '../utils/api';

const Podcasts = (): JSX.Element => {
  const { podcasts, loading, message, error } = useAppSelector((state) => state.podcasts);
  const [skeletonColumns] = useState([
    'Podcast ID',
    'Title',
    'Category',
    'Author',
    'Publisher',
    'Description',
    'Image',
    'Published Episodes',
    'Total Episodes',
  ]);
  const [skeletonRows] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]);

  const userInfo = useSelector((state: RootState) => state.userInfo.userInfo) as UserInfoType;

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (podcasts.length === 0) {
      fetchPodcasts(dispatch);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) {
    return (
      <div className="error">
        <span>{message}</span>
      </div>
    );
  }

  const permissions = userInfo?.permissions;

  return (
    <>
      {(permissions?.includes('podcasts.create') || userInfo?.isAdmin) && (
        <Link to="/podcast/add">
          <button
            type="button"
            className="add-button shadow bg-green-500 hover:bg-green-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4"
          >
            Add
          </button>
        </Link>
      )}
      <Content loading={false}>
        {loading ? <Skeleton columns={skeletonColumns} rows={skeletonRows} /> : <Table podcasts={podcasts} />}
      </Content>
    </>
  );
};

export default Podcasts;
